import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15 0a2 2 0 0 1 2 2v11h11a2 2 0 1 1 0 4H17v11a2 2 0 1 1-4 0V17H2a2 2 0 1 1 0-4h11V2a2 2 0 0 1 2-2"
    }, null, -1)
  ]))]))
}
export default { render: render }